import PropTypes from "prop-types";
import { connect } from "react-redux";

import actions from "@/actions";

import Tools from "../../tools-bar/tools";
import { getTopZIndex } from "./utils";

const TopBarGroupEditMode = ({
    changeMode,
    persistGroup,
    selectTool,
    pendingGroupGeometry,
    groupGeometries,
    setPendingGroupGeometry,
}) => {
    const cancel = () => {
        changeMode("view");
        selectTool(Tools.group);
    };

    const onDone = () => {
        // eslint-disable-next-line react-hooks/immutability
        pendingGroupGeometry.zIndex = getTopZIndex(groupGeometries);
        setPendingGroupGeometry(pendingGroupGeometry);
        persistGroup();
    };

    return (
        <div className="topBar">
            <div className="row">
                <div className="col-sm">
                    <p className="textTopbar">Edit Group</p>
                </div>
                <div className="col-sm">
                    <div className="link" onClick={cancel}>
                        Cancel
                    </div>
                </div>
                {pendingGroupGeometry && (
                    <div
                        className="col-sm d-flex align-items-center justify-content-end me-2"
                        onClick={onDone}
                    >
                        <button type="button" className="btn btn-dark done">
                            Done
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

TopBarGroupEditMode.propTypes = {
    changeMode: PropTypes.func.isRequired,
    persistGroup: PropTypes.func.isRequired,
    selectTool: PropTypes.func.isRequired,
    pendingGroupGeometry: PropTypes.object,
    groupGeometries: PropTypes.array.isRequired,
    setPendingGroupGeometry: PropTypes.func.isRequired,
};

const mapStateToProps = ({ map }) => ({
    pendingGroupGeometry: map.general.pendingGroupGeometry,
    groupGeometries: map.values.global.present.groupGeometries,
});

const mapDispatchToProps = {
    changeMode: actions.map.general.changeMode,
    persistGroup: actions.map.general.persistGroup,
    selectTool: actions.map.general.selectTool,
    setPendingGroupGeometry: actions.map.general.setPendingGroupGeometry,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TopBarGroupEditMode);
